export class SM_CONSTANTS {
  //----------  HTTP METHODS  ----------//
  public static readonly REQUEST_GET: string = "get";
  public static readonly REQUEST_POST: string = "post";
  public static readonly REQUEST_PUT: string = "put";
  public static readonly REQUEST_DELETE: string = "delete";

  //----------  API ENDPOINTS  ----------//
  public static readonly API_CHECK_USER: string = "checkUser";
  public static readonly API_GET_ALL_USERS: string = "getAllUsers";
  public static readonly API_GET_CONTACT_MESSAGES: string =
    "getContactMessages";
  public static readonly API_GET_SUBSCRIPTION_DETAIL: string =
    "getSubscriptionDetail";
    public static readonly API_CHECK_APP_CURRENT_VERSION: string =
    "public/checkAppCurrentVersion";
  
  public static readonly API_GET_USER_REQUEST: string = "getUserRequest";
  public static readonly API_UPDATE_USER_REQUEST_STATUS: string =
    "updateUserRequestStatus";
  public static readonly API_UPDATE_BUISNESS_PROMOTION_INFO: string =
    "updateBusinessPromotionInfo";
  public static readonly API_UPLOAD: string = "upload";
  public static readonly API_GET_BUISNESS_PROMOTION_LIST: string =
    "getBusinessPromotionList";
  public static readonly API_GET_ADMIN_POST_LIST: string = "getAdminPostList";
  public static readonly API_UPDATE_ADMIN_POST_INFO: string =
    "updateAdminPostInfo";
  public static readonly API_SEND_FCM_NOTIFICATION_TO_TOPIC: string =
    "createTargetedNotification";
  public static readonly API_GET_TARGETED_NOTIFICATIONS: string =
    "getTargetedNotificationList";
  public static readonly API_GET_COUPONS_LIST: string = "getEntityCoupons";
  public static readonly API_GET_BANK_INFO: string = "getBankInfo";
  public static readonly API_GET_SERVICE_TYPES_LIST: string =
    "public/getServiceTypesList";
  public static readonly API_GET_ENTITY_DETAILS: string = "getEntityDetails";
  public static readonly API_GET_ALL_ENTITY_DETAILS: string = "getAllEntity";
  public static readonly API_GET_ALL_ENTITY_SERVICE_PAYMENTS: string =
    "getEntityAllServicePayments";
  public static readonly API_GET_ALL_TRANSFERRED_ENTITY_PAYMENTS: string =
    "getAllTransferredEntityPayment";
  public static readonly API_GET_BUSINESS_LIST: string = "getAllEntityList";
  public static readonly API_GET_BUSINESS_DOCS_LIST: string = "getBusinessDocs";
  public static readonly API_CREATE_DISCOUNT_COUPON_LIST: string =
    "createDiscountCoupon";
  public static readonly API_UPDATE_BUSINESS_DOCS_STATUS: string =
    "addEditBusinessDoc";
  public static readonly API_UPDATE_BANK_INFO: string =
    "addEditBankAccountDetails";
  public static readonly API_ADD_UPDATE_SERVICE_TYPE: string =
    "updateServiceTypeInfo";
  public static readonly API_GET_SERVICE_TEMPLATES: string =
    "getServiceTemplateList";
  public static readonly API_ADD_SERVICE_TEMPLATES: string =
    "addEditServiceTemplateDetails";
  public static readonly API_UPDATE_ENTITY_INFO: string = "updateEntityInfo";
  public static readonly API_GET_BOOKINGS_LIST: string =
    "getHistoricBookingList";
  public static readonly API_GET_EMPLOYEE_LIST: string = "getEmployeeList";
  public static readonly API_GET_USER_DETAIL: string = "getUserDetail";
  public static readonly API_GET_POST_DETAIL: string = "getPostDetails";
  public static readonly API_ADD_CONTACT_MESSAGES: string =
    "addContactMessages";
  public static readonly API_GET_CITY_SPECIFIC_DATA: string =
    "cityBasedBusinessCount";
  public static readonly API_BLOCK_UNBLOCK_OPERATION: string =
    "blockUnblockOperation";

  public static readonly API_GET_REFERRAL_ACTIVITY: string =
    "getRefferalActivity";
  public static readonly API_UPDATE_REFERRAL_ACTIVITY_STATUS: string =
    "updateReferralActivityStatus";

  public static readonly API_GET_REFERRED_USER_DETAILS: string =
    "getReferredUserDetails";
  public static readonly API_GET_LATEST_BLOCKED_UNBLOCKED_ACCOUNTS: string =
    "getLatestBlockUnblockAccountRecords";
  public static readonly API_ADD_FREE_SUBSCRIPTION: string =
    "addFreeSubscription";

  public static readonly API_GET_UNUSED_QR_CODES: string = "getUnUsedQRCodes";
  public static readonly API_GET_LINKED_QR_CODES: string = "getLinkedQRCodes";
  public static readonly API_CREATE_QR_CODE: string = "createQRcode";
  public static readonly API_GET_BOOKING_QR_CODES: string =
    "getLatestBookingQRCode";
  public static readonly API_LINK_QR_CODE: string = "linkQRCode";
  public static readonly API_UNLINK_QR_CODE: string = "unLinkQRCode";
  public static readonly API_GET_CURRENT_STATISTICS: string =
    "getCurrentStatistics";
  public static readonly API_GET_APP_DATA_SETTINGS: string =
    "getAppDataSettings";
  public static readonly API_GET_ADVERTISERS: string = "getAdvertisers";
  public static readonly API_ADD_EDIT_APP_DATA_SETTINGS: string =
    "addEditAppDataSettings";
  public static readonly API_ADD_EDIT_ADVERTISERS: string = "addEditAdvertiser";
  public static readonly API_GET_ADVERTISERS_PROMOTIONAL_POST_CAMPAIGNS: string =
    "getPromotionalPostCampaigns";
  public static readonly API_GET_ADVERTISERS_BANNER_CAMPAIGNS: string =
    "getPromotionalBannerCampaigns";
  public static readonly API_GET_ADVERTISERS_TARGETTED_NOTIFICATION_CAMPAIGNS: string =
    "getTargetedNotificationCampaigns";
  public static readonly API_GET_ADVERTISERS_PAYMENTS: string =
    "getAdvertiserPayments";
  public static readonly API_SET_ADVERTISERS_PAYMENTS: string =
    "setAdvertiserPayment";
  public static readonly API_GET_FCM_TOPICS: string = "getAllFCMTopic";
  public static readonly API_ADD_EDIT_FCM_TOPIC: string = "addEditFCMTopic";
  public static readonly API_ASSIGN_SUBSCRIBER_TO_FCM_TOPIC: string =
    "assignSubscriberToFCMTopic";
  public static readonly API_GET_SUBSCRIBER_FROM_FCM_TOPICS: string =
    "getSubscriberFromFCMTopic";
  public static readonly API_REMOVE_SUBSCRIBER_FROM_FCM_TOPICS: string =
    "removeSubscriberFromFCMTopic";
  public static readonly API_GET_INVENTORY_ITEMS: string =
    "getInventoryDataByKeyword";
  public static readonly API_ADD_EDIT_INVENTORY_ITEM: string =
    "addEditInventoryItem";
  public static readonly API_GET_INVENTORY_ITEMS_TEMPLATE_LIST: string =
    "getInventoryItemTemplateList";
  public static readonly API_ADD_EDIT_INVENTORY_ITEM_TEMPLATE_LIST: string =
    "addEditInventoryItemTemplateDetails";

  //search

  public static readonly API_GET_SERVICE_TEMPLATE_DATA_BY_KEYWORD: string =
    "getServiceTemplateDataByKeyword";
  public static readonly API_GET_SERVICE_DATA_BY_KEYWORD: string =
    "getServiceDataByKeyword";
  public static readonly API_GET_INVENTORY_TEMPLATE_DATA_BY_KEYWORD: string =
    "getInventoryTemplateDataByKeyword";
  public static readonly API_GET_INVENTORY_DATA_BY_KEYWORD: string =
    "getInventoryDataByKeyword";

  //functionality
  public static readonly API_GET_APP_FUNCTIONALITY_LIST: string =
    "getAppFunctionalityList";
  public static readonly API_ADD_EDIT_APP_FUNCTIONALITY_LIST: string =
    "addEditAppFunctionality";
  public static readonly API_GET_APP_FUNCTIONALITY_BY_ENTITY_ID: string =
    "getFunctionalityByEntityId";
  public static readonly API_ADD_EDIT_APP_FUNCTIONALITY_TO_ENTITY: string =
    "addEditFunctionalityToEntity";
  //

  public static readonly API_GET_ENTITY_SLOTS_INFO: string =
    "getEntitySlotsInfo";
  public static readonly API_UPDATE_BOOKING_STATUS: string =
    "updateBookingStatus";
  public static readonly API_RESET_BOOKING_DETAILS: string =
    "resetBookingDetails";
  public static readonly API_GET_ENTITY_INVOICE_DETAILS: string =
    "getEntityInvoiceDetails";
  public static readonly API_ADD_EDIT_ENTITY_INVOICE_DETAILS: string =
    "addEditEntityInvoice";
  public static readonly API_GET_BOOKING_OPERATION_DETAILS: string =
    "getBookingOperationDetails";
  public static readonly API_CUSTOMISE_BOOKING_DETAILS: string =
    "customizeBookingDetails";
  public static readonly API_RESET_INVOICE_DATA: string = "resetInvoiceData";
  public static readonly API_ADD_EDIT_PAYMENT_RECORD: string =
    "addEditPaymentRecord";
  public static readonly API_CONTACT_US: string = "public/contactUs";
  public static readonly API_SET_REQUEST: string = "setRequest";
  public static readonly API_UPDATE_MESSAGE_THREAD: string =
    "updateMessageThread";
  public static readonly API_UPDATE_MESSAGE: string = "updateMessage";
  public static readonly API_ENABLE_ONLINE_PAYMENTS: string =
    "enableOnlinePayments";
  public static readonly API_CREATE_SUPPORT_TICKET: string =
    "createSupportTicket";
  public static readonly API_CREATE_SUPPORT_TICKET_RESPONSE: string =
    "createSupportTicketResponse";


  /**Tax and GST */

  public static readonly API_GET_ENTITY_TAX_DATA: string = "getEntityTaxData";
  public static readonly API_ADD_EDIT_ENTITY_TAX_DATA: string =
    "addEditEntityTaxData";
  public static readonly API_GET_ENTITY_BILL_DISCOUNT: string =
    "getBillDiscount";
  public static readonly API_ADD_EDIT_ENTITY_BILL_DISCOUNT: string =
    "addEditBillDiscount";
  public static readonly API_GET_SUBSCRIPTION_HISTORY_BY_ID: string =
    "getSubscriptionHistoryById";
  public static readonly API_UPDATE_ENTITY_SUBSCRIPTION_INFO: string =
    "updateEntitySubsciptionInfo";
  public static readonly API_GET_PLANS_LIST: string = "public/getPlansList";
  public static readonly API_CREATE_SUBSCRIPTION_ORDER: string =
    "createSubscriptionOrder";
  public static readonly API_VALIDATE_PAYMENT_SIGNATURE: string =
    "validatePaymentSignature";
  public static readonly API_UPDATE_PAYMENT_RECORD: string =
    "updatePaymentRecord";
  public static readonly API_GET_SHOP_SERVICE_TIMINGS: string =
    "public/getEntityTimeDetails";
  public static readonly API_GET_HOME_SERVICE_TIMINGS: string =
    "public/getHomeSeviceTimeDetails";
  public static readonly API_UPDATE_ENTITY_SHOP_SERVICE_TIMINGS: string =
    "updateEntityTimeInfo";
  public static readonly API_UPDATE_ENTITY_HOME_SERVICE_TIMINGS: string =
    "updateHomeServiceTimeInfo";
  public static readonly API_UPDATE_FCM_TOKEN_INFO: string =
    "public/updateFcmTokenInfo";
  public static readonly API_GET_NOTIFICATIONS: string = "getNotifications";
  public static readonly API_GET_FEEDBACKS: string = "public/getFeedBacks";
  public static readonly API_GET_BOOKING_QR: string = "getLatestBookingQRCode";
  public static readonly API_CREATE_BOOKING_QR: string = "createBookingQRCode";
  public static readonly API_UPDATE_USER_PROFILE: string = "updateUserProfile";
  public static readonly API_GET_ENTITY_ACTIVE_SUBSCRIPTION: string =
    "getEntityActiveSubscription";
  public static readonly API_GET_EMPLOYEE_REQUEST_LIST: string =
    "getEmployeeRequestList";
  public static readonly API_SEND_EMPLOYEE_REQUEST: string =
    "sendEmployeeRequest";
  public static readonly API_GET_SALARY_INFO: string = "getSalaryInfo";
  public static readonly API_UPDATE_SALARY_INFO: string = "updateSalaryInfo";
  public static readonly API_GET_USER_EXPENSES_LIST: string =
    "getUserExpensesList";
  public static readonly API_UPDATE_USER_EXPENSES_INFO: string =
    "updateUserExpenseInfo";
  public static readonly API_UPDATE_USER_SUBSCRIPTION_INFO: string =
    "updateUserSubsciptionInfo";
  public static readonly API_GET_TRANSACTIONS_LIST: string =
    "getTransactionsList";
  public static readonly API_GET_EMPLOYEE_SUBSCRIPTION_INFO: string =
    "getEmployeeSubscriptionInfo";
  public static readonly API_GET_EMPLOYEE_DUTY_LOG: string =
    "getEmployeeDutyLog";
  public static readonly API_ADD_AS_EMPLOYEE: string = "addAsEmployee";
  public static readonly API_UPDATE_EMPLOYEE_INFO: string =
    "updateEmployeeInfo";
  public static readonly API_GET_CUSTOMERS_BY_ENTITY_ID: string =
    "getCustomersByEntityId";
  public static readonly API_GET_CUSTOMERS_WITH_DUES_BY_ENTITY_ID: string =
    "getCustomersWithDuesByEntityId";
  public static readonly API_GET_LONG_ABSENT_CUSTOMERS_BY_ENTITY_ID: string =
    "getLongAbsentCustomersByEntityId";
  public static readonly API_GET_ENTITY_CUSTOMER_BOOKING_HISTORY: string =
    "getEntityCustomerBookingHistory";
  public static readonly API_GET_ENTITY_CUSTOMER_DUE_BOOKING_HISTORY: string =
    "getEntityCustomerDueBookingList";
  public static readonly API_GET_BOOKING_DETAIL_BY_ID: string =
    "getBookingDetailById";
  public static readonly API_GET_CUSTOMER_BY_SEARCH: string =
    "getCustomerDataByKeyword";
  public static readonly API_SET_NOTIFICATION_PRIVACY: string =
    "setNotificationPrivacy";
  public static readonly API_GET_MESSAGES_BY_ID: string = "getMessagesByID";
  public static readonly API_GET_SUB_MESSAGES_BY_ID: string =
    "getSubMessagesByID";
  public static readonly API_GET_ENTITY_INVENTORY_IN_OUT_DATA: string =
    "getEntityInventoryInOutData";
  public static readonly API_GET_ENTITY_INVENTORY_ITEMS: string =
    "getInventoryItems";
  public static readonly API_SET_INVENTORY_ITEM_ACTIVITY: string =
    "setInventoryItemActivity";
  public static readonly API_EDIT_INVENTORY_ACTIVITY: string =
    "editInventoryActivity";
  public static readonly API_ENTITY_PURCHASE_ITEMS: string =
    "getEntityPurchaseItems";
  public static readonly API_ENTITY_PURCHASE_OVERVIEW: string =
    "getEntityPurchaseOverview";
  public static readonly API_ENTITY_EXPENSES_OVERVIEW: string =
    "getEntityExpenseOverview";
  public static readonly API_ADD_EDIT_PURCHASE_ITEM: string =
    "addEditPurchaseItem";
  public static readonly API_GET_EXPENSES_LIST: string = "getExpensesList";
  public static readonly API_UPDATE_EXPENSE_INFO: string = "updateExpenseInfo";
  public static readonly API_GET_ENTITY_FOLLOWING_LIST: string =
    "getEntityFollowingList";
  public static readonly API_GET_POSTS_AS_PER_ID: string = "getPostsAsPerID";
  public static readonly API_GET_ALL_ASSETS_AS_PER_ID: string =
    "getAllAssetsAsPerID";
  public static readonly API_GET_FEED_AS_PER_BUSINESS_ID: string =
    "getFeedAsPerBusinessID";
  public static readonly API_SEND_UNBLOCK_REQUEST: string =
    "public/sendUnblockRequest";
  public static readonly API_SET_SUPPORT_TICKET_STATUS: string =
    "setSupportTicketStatus";
  public static readonly API_GET_MESSAGE_NOTIFICATION_STATUS: string =
    "v2/getMessageNotificationStatus";

  //----------  REPORT API ENDPOINTS  ----------//
  public static readonly API_GET_SALES_REPORT: string = "getSalesReport";
  public static readonly API_GET_EMPLOYEE_SALES_REPORT: string =
    "getEmployeeSalesReport";
  public static readonly API_GET_EXPENDITURE_REPORT: string =
    "getExpenditureReport";
  public static readonly API_GET_EMPLOYEE_SALARY_REPORT: string =
    "EmployeeSalaryReport";
  public static readonly API_GET_BOOKING_REPORT: string = "getBookingReport";
  public static readonly API_GET_SERVICE_REPORT: string = "getServiceReport";
  public static readonly API_GET_INVOICE_REPORT: string =
    "getEntityInvoiceListForReport";
  public static readonly API_GET_PAYMENT_REPORT: string =
    "getEntityServicePaymentsForTransfer";
  public static readonly API_GET_INVENTORY_ACTIVITY_REPORT: string =
    "getInventoryActivityReport";
  public static readonly API_GET_PURCHASE_REPORT: string = "getPurchaseReport";
  public static readonly API_GET_REVENUE_INSIGHT_REPORT: string =
    "getRevenueInsightReport";
  public static readonly API_GET_TAX_COLLECTION_REPORT: string =
    "getTaxCollectionReport";
  public static readonly API_GENERATE_INVOICE_PDF: string = 
    "generateInvoicePDF";
  public static readonly API_GENERATE_INTERNATIONAL_INVOICE_PDF: string =
    "v2/generateInternationalInvoicePDF";
  public static readonly API_GET_ENTITY_SPECIFIC_SUPPORT_TICKETS: string =
    "getEntitySpecificSupportTickets";
  public static readonly API_GET_SUPPORT_THREAD: string = "getSupportThread";
  public static readonly API_GET_ENTITY_SERVICE_TEMPLATES: string =
    "public/getEntityServiceTemplates";

  public static readonly API_GET_TODAY_BOOKINGS_FOR_DASHBOARD: string =
    "v2/getTodaysBookingsForDashboard";
  public static readonly API_GET_TODAY_BOOKINGS_FOR_DASHBOARD_COUNT: string =
    "v2/getTodaysBookingsCountForDashboard";

  public static readonly API_GET_UPCOMING_BOOKINGS_FOR_DASHBOARD: string =
    "v2/getUpcomingBookingsForDashboard";
  public static readonly API_GET_UPCOMING_BOOKINGS_FOR_DASHBOARD_COUNT: string =
    "v2/getUpcomingBookingsCountForDashboard";
  
    public static readonly API_GET_LATEST_PURCHASES_FOR_DASHBOARD: string =
    "v2/getLatestPurchasesForDashboard";
    public static readonly API_GET_LATEST_PURCHASES_FOR_DASHBOARD_COUNT: string =
    "v2/getLatestPurchasesCountForDashboard";
 
    public static readonly API_GET_LATEST_INVENTORY_STATUS_FOR_DASHBOARD: string =
    "v2/getLatestInventoryStatusForDashboard";
    public static readonly API_GET_LATEST_INVENTORY_STATUS_FOR_DASHBOARD_COUNT: string =
    "v2/getLatestInventoryStatusCountForDashboard";
  
    public static readonly API_GET_LATEST_EXPENSES_FOR_DASHBOARD: string =
    "v2/getLatestExpensesForDashboard";
    public static readonly API_GET_LATEST_EXPENSES_FOR_DASHBOARD_COUNT: string =
    "v2/getLatestExpensesCountForDashboard";
  
    public static readonly API_GET_TODAYS_EMPLOYEE_LOG_FOR_DASHBOARD: string =
    "v2/getTodaysEmployeeLogForDashboard";
    public static readonly API_GET_TODAYS_EMPLOYEE_LOG_FOR_DASHBOARD_COUNT: string =
    "v2/getTodaysEmployeeLogCountForDashboard";
  
    public static readonly API_GET_COMPOSITE_SALES_DATA_FOR_DASHBOARD: string =
    "v2/getCompositeSalesDataForDashboard";
  public static readonly API_GET_COMPOSITE_BOOKING_DATA_FOR_DASHBOARD: string =
    "v2/getCompositeBookingDataForDashboard";
  public static readonly API_GET_COMPOSITE_EXPENDITURE_DATA_FOR_DASHBOARD: string =
    "v2/getCompositeExpenditureDataForDashboard";
  public static readonly API_GET_ASSIGNED_TASK_COUNT_FOR_DASHBOARD: string =
    "v2/getAssignedTaskCountForDashboard";
  public static readonly API_GET_ASSIGNED_TASK_LIST_FOR_DASHBOARD: string =
    "v2/getAssignedTaskListByUser";
  public static readonly API_GET_COMPLETED_TASK_LIST_FOR_DASHBOARD: string =
    "v2/getCompletedTaskListByUser";

  
  public static readonly API_GET_ENTITY_FEATURE_WISE_COUNTS: string =
    "v2/getEntityFeatureWiseCounts";
  public static readonly API_UPDATE_ENTITY_SERVICES: string =
    "v2/updateEntityServices";
  public static readonly API_UPDATE_ENTITY_DETAILS: string =
    "v2/updateEntityDetails";
  public static readonly API_UPLOAD_ENTITY_MEDIA: string =
    "v2/uploadEntityMedia";
  public static readonly API_UPDATE_ENTITY_LOCATION: string =
    "v2/updateEntityLocation";
  public static readonly API_DEACTIVATE_ENTITY: string =
    "v2/deactivateEntity";
  public static readonly API_SET_MEDIA_AS_DEFAULT: string =
    "v2/setMediaAsDefault";
  public static readonly API_DELETE_UPLOADED_MEDIA: string =
    "v2/deleteUploadedMedia";
  public static readonly API_GET_BASIC_ENTITY_LIST: string =
    "v2/getBasicEntityList";
  public static readonly API_GET_EMPLOYEE_DETAILS: string =
    "v2/getEmployeeDetails";
  public static readonly API_GET_EMPLOYEE_FEATURE_WISE_COUNT: string =
    "v2/getEmployeeFeatureWiseCounts";
  public static readonly API_SET_NOTIFICATION_READ_STATUS: string =
    "v2/setNotificationReadStatus";
  public static readonly API_GET_ENTITY_DISCOUNT: string =
    "v2/getBillDiscountData";
  public static readonly API_SEND_EMAIL: string =
    "v2/sendEmail";
  public static readonly API_SEND_WHATSAPP: string =
    "v2/sendWhatsAppMessage";
  public static readonly API_GET_VIRTUAL_SERVICE_TIMINGS: string =
    "v2/public/getVirtualServiceTimings";
  public static readonly API_UPDATE_VIRTUAL_SERVICE_TIMINGS: string =
    "v2/updateVirtualServiceTimingInfo";
  public static readonly API_DELETE_ENTITY_BY_OWNER: string =
    "v2/deleteEntityByOwner";
  public static readonly API_SET_EMPLOYEE_ACTIVATION_STATUS: string =
    "v2/setEmployeeActivationStatus";
  public static readonly API_GET_ENTITY_INVENTORY_STATUS: string =
    "v2/getEntityInventoryStatus";
  public static readonly API_GET_ENROLL_INTEREST_BY_ENTITY_ID: string =
    "v2/getAllEnrollInterestByEntityId";
  public static readonly API_ADD_EDIT_ENROLL_INTEREST_BY_ENTITY: string =
    "v2/addEditEnrollInterestByEntity";
  public static readonly API_GET_ENROLL_INTEREST_DETAILS_BY_ID: string =
    "v2/getEnrollInterestDetailsById";
  public static readonly API_UPDATE_ENROLL_PROGRESS_STATUS: string =
    "v2/updateEnrollInterestProgressStatus";
  public static readonly API_UPDATE_ENROLL_STATUS: string =
    "v2/updateEnrollInterestStatus";
  public static readonly API_GET_FITNESS_AUTOCORRECT: string =
    "v2/getFitnessEnrolledMemberForAutoCorrect";
  public static readonly API_GET_SEARCH_BY_ENROLL_INTEREST: string =
    "v2/getSearchByEnrollInterest";
  public static readonly API_GET_ENROLL_MEMBERS_SEARCH_BY_TYPE: string =
    "v2/getEnrolledMembersListByType";
  public static readonly API_ADD_EDIT_ENROLL_MEMBERS: string =
    "v2/addEditEnrolledMember";
  public static readonly API_ADD_EDIT_FITNESS_ENTITY_INVOICE: string =
    "v2/addEditFitnessEntityInvoice";
  public static readonly API_ADD_EDIT_ENTITY_INVOICE_WITHOUT_BOOKING: string =
    "v2/addEditEntityInvoiceWithoutBooking";
  public static readonly API_ADD_EDIT_INTERNATIONAL_ENTITY_INVOICE_WITHOUT_BOOKING: string =
    "v2/addEditInternationalEntityInvoiceWithoutBooking";
  public static readonly API_GET_MEMBER_INVOICE_DETAILS: string =
    "v2/getEntityInvoiceDetailsByHash";
  public static readonly API_GET_ENROLLED_MEMBER_DETAILS: string =
    "v2/getEnrolledMemberDetails";
  public static readonly API_GET_ENTITY_MEMBER_ALL_INVOICE_LIST: string =
    "v2/getEntityMembersAllInvoiceList";
  public static readonly API_GET_ENTITY_MEMBER_DUE_INVOICE_LIST: string =
    "v2/getEntityMemberDueInvoiceList";
  public static readonly API_UPDATE_ENROLLED_MEMBER_MEMBERSHIP_STATUS: string =
    "v2/updateEnrolledMemberMembershipStatus";
  public static readonly API_ADD_EDIT_CUSTOMER_BY_ENTITY: string =
    "v2/addEditCustomerByEntity";
    public static readonly API_DELETE_ENTITY_APPOINTMENT_DATA: string =
    "v2/deleteEntityAppointmentData";
    public static readonly API_DELETE_ENTITY_CUSTOMER_DATA: string =
    "v2/deleteEntityCustomer";
    public static readonly API_DELETE_ENTITY_MEMBER_DATA: string =
    "v2/deleteEntityMember";
    public static readonly API_DELETE_ENTITY_REQUEST_DATA: string =
    "v2/deleteEntityRequestData";
    public static readonly API_RECORD_FITNESS_INVOICE: string =
    "v2/addEditFitnessInvoicePaymentRecord";
    public static readonly API_DELETE_ENTITY_INVOICE: string =
    "v2/deleteEntityInvoice";
    public static readonly API_SEND_INVOICE_EMAIL: string =
    "v2/sendInvoiceViaEmail";
    public static readonly API_SEND_INTERNATIONAL_INVOICE_EMAIL: string =
    "v2/sendInternationalInvoiceViaEmail";
    public static readonly API_GET_INTERNATIONAL_ENTITY_TAX_DATA: string =
    "v2/getInternationalEntityTaxData";
    public static readonly API_ADD_EDIT_INTERNATIONAL_ENTITY_TAX_DATA: string =
    "v2/addEditInternationalEntityTaxData";
    public static readonly API_GET_INTERNATIONAL_ENTITY_INVOICE_DETAILS: string =
    "v2/getInternationalEntityInvoiceDetails";
    public static readonly API_ADD_EDIT_INTERNATIONAL_ENTITY_INVOICE: string =
    "v2/addEditInternationalEntityInvoice";
    public static readonly API_ADD_EDIT_INTERNATIONAL_FITNESS_ENTITY_INVOICE: string =
    "v2/addEditInternationalFitnessEntityInvoice";
    public static readonly API_GET_INTERNATIONAL_FITNESS_ENTITY_INVOICE_DETAILS: string =
    "v2/getInternationalEntityInvoiceDetailsByHash";
    public static readonly API_GET_INTERNATIONAL_ENTITY_INVOICE_LIST_FOR_REPORTS: string =
    "v2/getInternationalEntityInvoiceListForReports";
    public static readonly API_GET_INTERNATIONAL_ENTITY_TAX_COLLECTION_REPORT: string =
    "v2/getInternationalTaxCollectionReport";
    public static readonly API_GET_INTERNATIONAL_SALES_REPORT: string =
    "v2/getInternationalSalesReport";
    public static readonly API_GET_INTERNATIONAL_REVENUE_INSIGHT_REPORT: string =
    "v2/getInternationalRevenueInsightReport";
    public static readonly API_ADD_EDIT_INTERNATIONAL_INVOICE_PAYMENT_RECORD: string =
    "v2/addEditInternationInvoicePaymentRecord";
    public static readonly API_ADD_EDIT_FITNESS_INTERNATIONAL_INVOICE_PAYMENT_RECORD: string =
    "v2/addEditFitnessInternationalInvoicePaymentRecord";
    public static readonly API_DELETE_INTERNATIONAL_INVOICE_DETAILS: string =
    "v2/deleteInternationalInvoiceDetails";
    public static readonly API_ADD_EDIT_INTERNATIONAL_ENTITY_TAX_CONFIGURATION: string =
    "v2/addEditInternationalEntityTaxConfiguration";
    public static readonly API_GET_ENTITY_TAX_SLAB_DATA: string =
    "v2/getEntityTaxSlabData";
    public static readonly API_ADD_ENTITY_PRIMARY_TAX_DATA: string =
    "v2/addEditEntityPrimaryTaxData";
    public static readonly API_GET_INTERNATIONAL_ENTITY_TAX_SLAB_DATA: string =
    "v2/getInternationalEntityTaxSlabsData";
    public static readonly API_ADD_EDIT_INTERNATIONAL_ENTITY_TAX_SLABS_DATA: string =
    "v2/addEditInternationalEntityTaxSlabsData";
    public static readonly API_DELETE_ENTITY_TAX_SLAB_DATA: string =
    "v2/deleteEntityTaxSlabData";
    public static readonly API_DELETE_INTERNATIONAL_ENTITY_TAX_SLAB_DATA: string =
    "v2/deleteInternationalEntityTaxSlabData";
    public static readonly API_ADD_EDIT_ENTITY_PRODUCT: string =
    "v2/addEditEntityProduct";
    public static readonly API_DELETE_ENTITY_PRODUCT: string =
    "v2/deleteEntityProduct";
    public static readonly API_GET_ENTITY_PRODUCT_LIST: string =
    "v2/getEntityProductList";
    public static readonly API_GET_PRODUCT_DATA_BY_KEYWORD: string =
    "v2/getProductDataByKeywod";
    public static readonly API_GET_BOOKINGS_FOR_FITNESS_ENTITY: string =
    "v2/getBookingsForFitnessEntity";
    public static readonly API_GET_HISTORIC_BOOKING_LIST_FOR_FITNESS_ENTITY: string =
    "v2/getHistoricBookingListForFitnessEntity";
    public static readonly API_GET_HISTORIC_ATTENDANCE_LIST_FOR_FITNESS_ENTITY: string =
    "v2/getHistoricAttendanceListForFitnessEntity";
    public static readonly API_MARK_MEMBER_ATTENDANCE_STATUS: string =
    "v2/markMemberAttendanceStatus";
    public static readonly API_GET_MEMBERSHIP_REPORT: string =
    "v2/getMembershipReport";
    public static readonly API_GET_ACCOUNT_DATA_BY_PHONE_NUMBER: string =
    "v2/getAccountDataByPhoneNumber";
    public static readonly API_GET_MEMBER_ATTENDANCE_BY_ENTITY: string =
    "v2/getMemberAttendanceByEntity";
    public static readonly API_MARK_MEMBER_ABSENT_BY_ENTITY: string =
    "v2/markMemberAbsentByEntity";
    public static readonly API_SET_ENROLLED_MEMBER_PHONE_NUMBER: string =
    "v2/setEnrolledMemberPhoneNumber";
    public static readonly API_DELETE_MEMBER_ATTENDANCE_DATA_BY_ENTITY: string =
    "v2/deleteMemberAttendanceDataByEntity";
    public static readonly API_SET_MESSAGE_READ_STATUS: string =
    "v2/setMessageReadStatus";
    public static readonly API_GET_ENTITY_CUSTOMER_PAYMENT_HISTORY: string =
    "v2/getEntityCustomerPaymentHistory";
    public static readonly API_GET_MEMBER_DATA_BY_KEYWORD: string =
    "v2/getMemberDataByKeyword";
    public static readonly API_UPDATE_POST_INFO: string =
    "updatePostInfo";
    public static readonly API_SET_EMPLOYEE_DUTY_DATA: string =
    "setEmployeeDutyData";
    public static readonly API_GET_JOB_INVITATIONS: string =
    "v2/getJobInvitations";
    public static readonly API_GET_EMPLOYER_LIST: string =
    "getEmployerList";
    public static readonly API_GET_COUNTRY_DATA: string =
    "v2/getCountryData";
    public static readonly API_GET_JOB_INVITATION_DETAILS: string =
    "v2/getJobInvitationDetails";
    public static readonly API_ASSIGN_EMPLOYEE_TO_MEMBER: string =
    "v2/assignEmployeeToMember";
    public static readonly API_UPDATE_MEMBER_SESSION: string =
    "v2/UpdateMemberSession";
    public static readonly API_DELETE_LINKED_BANK_ACCOUNT: string =
    "v2/deleteLinkedBankAccount";
    public static readonly API_LINK_ENTITY_BANK_ACCOUNT: string =
    "v2/linkEntityBankAccount";
    public static readonly API_GET_UNAVAILABILITY_LIST_OF_ENTITY: string =
    "v2/getUnavailabilityListOfEntity";
    public static readonly API_SET_UNAVAILABILITY_FOR_ENTITY: string =
    "v2/setUnavailabilityForEntity";
    public static readonly API_REMOVE_UNAVAILABILITY_FOR_ENTITY: string =
    "v2/removeUnavailabilityForEntity";
    public static readonly API_GET_SERVICE_PAYMENT_LINK_FOR_ENTITY_INVOICE: string =
    "v2/getServicePaymentLinkForEntityInvoice";
    public static readonly API_GET_CUSTOMER_LIST_FOR_AUTOCOMPLETE: string =
    "v2/getCustomerListForAutoComplete";
    public static readonly API_UNLINK_BANK_ACCOUNT_FROM_BUSINESS: string =
    "v2/unlinkBankAccountFromBusiness";
    public static readonly API_UPDATE_VIRTUAL_MEETING_DATA: string =
    "v2/updateVirtualMeetingDetails";
    public static readonly API_UPDATE_BOOKING_NOTE: string =
    "v2/updateBookingNote";
    public static readonly API_RECORD_PURCHASE_PAYMENT: string =
    "v2/recordPurchasePayment";
    public static readonly API_SEND_EMAIL_VERIFICATION_LINK: string =
    "v2/sendEmailVerificationLink";
    public static readonly API_GET_INTERNATIONAL_ENTITY_ALL_SERVICE_PAYMENT: string =
    "v2/getInternationalEntityAllServicePayments";
    public static readonly API_GET_MEMBER_SESSION_DETAILS: string =
    "v2/getMemberSessionDetails";
    public static readonly API_GET_ENTITY_WHATSAPP_CAMPAIGN_LIST: string =
    "v2/getEntityExternalCampaignList";
    public static readonly API_GET_ENTITY_WHATSAPP_CAMPAIGN_TARGETS: string =
    "v2/getEntityWhatsAppCampaignTargets";
    public static readonly API_ADD_EDIT_ENTITY_WHATSAPP_CAMPAIGN: string =
    "v2/addEditEntityExternalCampaign";
    public static readonly API_DELETE_ENTITY_WHATSAPP_CAMPAIGN: string =
    "v2/deleteEntityExternalCampaign";
        public static readonly API_GET_EMPLOYEE_LIST_WITH_ASSIGNMENT: string =
    "v2/getEmployeeListWithAssignment";
      public static readonly API_GET_INTERNATIONAL_ENTITY_BANK_INFO: string =
    "v2/getInternationalEntityBankInfo";
    public static readonly API_ENABLE_INTERNATIONAL_ONLINE_PAYMENTS: string =
    "v2/enableInternationalOnlinePayments";
    public static readonly API_CREATE_PAYPAL_PARTNER_ACCOUNT: string =
    "v2/createPaypalPartnerAccount";
    public static readonly API_UPDATE_PAYPAL_SELLER_ACCOUNT_DETAILS: string =
    "v2/updatePaypalSellerAccountDetails";
    public static readonly API_LINK_INTERNATIONAL_ENTITY_BANK_ACCOUNT: string =
    "v2/linkInternationalEntityBankAccount";
    public static readonly API_UNLINK_INTERNATIONAL_ENTITY_BANK_ACCOUNT: string =
    "v2/unlinkBankAccountFromInternationalBusiness";
     public static readonly API_SYNC_LATEST_PAYPAL_DATA: string =
    "v2/syncLatestPayPalData";
        public static readonly API_GET_ENTITY_FAVOURITES_LIST: string =
    "v2/getEntityFavouritesList";
     public static readonly API_GET_POST_CREATE_ELIGIBILITY: string =
    "v2/getPostCreateEligibility";
       public static readonly API_GET_PROGRESS_TRACKERS_FOR_MEMBER: string =
    "v2/getProgressTrackersForMember";
    public static readonly API_ADD_EDIT_PROGRESS_TRACKER: string =
    "v2/addEditProgressTracker";
    public static readonly API_ADD_EDIT_PROGRESS_DATA: string =
    "v2/addEditTrackerProgressData";
    public static readonly API_GET_PROGRESS_DATA_BY_TRACKER: string =
    "v2/getProgressDataByTracker";
        public static readonly API_CREATE_RAZORPAY_SUB_MERCHANT_ACCOUNT: string =
    "v2/createRazorPaySubMerchantAccount";
    public static readonly API_UPDATE_RAZORPAY_SUB_MERCHANT_ACCOUNT_DETAILS: string =
    "v2/updateRazorPaySubMerchantAccountDetails";
     public static readonly API_LINK_DOMESTIC_ENTITY_BANK_ACCOUNT: string =
    "v2/linkDomesticEntityBankAccount";
    public static readonly API_GET_DOMESTIC_ENTITY_BANK_INFO: string =
    "v2/getDomesticEntityBankInfo";
        public static readonly API_GET_ALL_ENROLL_OPEN_INTEREST_BY_ENTITY_ID: string =
    "v2/getAllEnrollOpenInterestByEntityHash";
      public static readonly API_GET_WHATSAPP_EMAIL_QUOTA_USAGE: string =
    "v2/getWhatsAppEmailQuotaAndUsage";
     public static readonly API_GET_MEMBER_AUTO_INVOICE_SENDING_SETTINGS: string =
    "v2/getMembershipSettings";
    public static readonly API_SET_MEMBER_AUTO_INVOICE_SENDING_SETTINGS: string =
    "v2/setMembershipSettings";
    public static readonly API_GET_FUNCTIONALITY_BY_EMPLOYEE_ID: string =
    "v2/getFunctionalityByEmployeeId";
    public static readonly API_UPDATE_EMPLOYEE_FUNCTIONALITY_ACCESS_STATUS: string =
    "v2/updateEmployeeFunctionalityAccessStatus";
       public static readonly API_GET_BOOKING_ADVANCE_PAYMENT_SETTINGS: string =
  "v2/getBookingAdvancePaymentSettings";
    public static readonly API_SET_BOOKING_ADVANCE_PAYMENT_SETTINGS: string =
  "v2/setBookingAdvancePaymentSettings";
  public static readonly API_ADD_EDIT_ENTITY_ADVANCE_INVOICE: string =
    "addEditEntityAdvanceInvoice";
      public static readonly API_ADD_EDIT_INTERNATIONAL_ENTITY_ADVANCE_INVOICE: string =
    "v2/addEditInternationalEntityAdvanceInvoice";
        public static readonly API_CANCEL_ENTITY_APPOINTMENT_DATA: string =
  "v2/cancelEntityAppointmentData";
    public static readonly API_GET_WALLET_MONEY_FOR_ENTITY_CUSTOMER: string =
  "v2/getWalletMoneyForEntityCustomer";
    public static readonly API_GET_USER_TOTAL_WALLET_AMOUNT_FOR_ENTITY: string =
  "v2/getUserTotalWalletAmountForEntity";
    public static readonly API_GET_USER_WALLET_TRANSACTIONS_LIST_FOR_ENTITY: string =
  "v2/getUserWalletTransactionsListForEntity";
    public static readonly API_ADD_TRANSACTION_TO_WALLET: string =
  "v2/addTransactionToWallet";
    public static readonly API_UPDATE_WALLET_REFUND_STATUS: string =
  "v2/updateWalletRefundStatus";
    public static readonly API_DELETE_WALLET_TRANSACTION: string =
  "v2/deleteWalletTransaction";
    public static readonly API_UPDATE_ENTITY_ENQUIRY_PROGRESS_STATUS: string =
  "v2/updateEnityEnquiryProgressStatus";
    public static readonly API_GET_ENTITY_ENQUIRY_DETAILS: string =
  "v2/getEntityEnquiryDetails";
    public static readonly API_GET_ENTITY_ENQUIRY_LIST: string =
  "v2/getEntityEnquiryList";
     public static readonly API_EDIT_MEMBER_SERVICE_PRODUCT_OTHER_DATA: string =
  "v2/editMemberServiceProductOtherData";
    public static readonly API_EDIT_MEMBER_TIMINGS_DATA: string =
  "v2/editMemberTimingsData";
    public static readonly API_EDIT_MEMBER_PERSONAL_DETAILS: string =
  "v2/editMemberPersonalDetails";
      public static readonly API_GET_ENTITY_ALL_ENQUIRY_LIST: string =
  "v2/getEntityAllEnquiryList";
   public static readonly API_SET_ENTITY_LOYALTY_CONFIGURATION: string =
  "v2/setEntityLoyaltyConfiguration";
    public static readonly API_SET_ENTITY_BOOKING_LOYALTY_CONFIGURATION: string =
  "v2/setEntityBookingLoyaltyConfiguration";
    public static readonly API_SET_ENTITY_PAYMENT_LOYALTY_CONFIGURATION: string =
  "v2/setEntityPaymentLoyaltyConfiguration";
    public static readonly API_SET_ENTITY_REFERRAL_LOYALTY_CONFIGURATION: string =
  "v2/setEntityReferralLoyaltyConfiguration";
    public static readonly API_GET_ENTITY_LOYALTY_CONFIGURATION: string =
  "v2/getEntityLoyaltyConfiguration";
      public static readonly API_SET_REWARD_POINT_CONVERSION_FOR_ENTITY: string =
  "v2/setRewardPountConversionForEntity";
    public static readonly API_GET_REWARD_POINT_CONVERSION_FOR_ENTITY: string =
  "v2/getRewardPountConversionForEntity";
     public static readonly API_GET_USER_TOTAL_REWARD_AMOUNT_FOR_ENTITY: string =
  "v2/getUserTotalRewardAmountForEntity";
    public static readonly API_GET_USER_REWARD_TRANSACTION_LIST_FOR_ENTITY: string =
  "v2/getUserRewardTransactionsListForEntity";
      public static readonly API_REFUND_PAYMENT_TO_CUSTOMER: string =
  "v2/refundPaymentToCustomer";

    public static readonly API_SET_ENTITY_MEMBERSHIP_LOYALTY_CONFIGURATION: string =
  "v2/setEntityMembershipLoyaltyConfiguration";
      public static readonly API_TRANSFER_REWARDS_TO_WALLET: string =
  "v2/transferRewardsToWallet";
      public static readonly API_GET_LATEST_UNPAID_INVOICE_STATUS_COUNT_FOR_DASHBOARD: string =
  "v2/getLatestUnpaidInvoiveStatusCountForDashboard";
      public static readonly API_GET_LATEST_UNPAID_INVOICE_STATUS_FOR_DASHBOARD: string =
  "v2/getLatestUnpaidInvoiceStatusForDashboard";
     public static readonly API_SET_ENTITY_PUBLIC_POST_PERMISSION_STATUS: string =
  "v2/setEntityPublicPostPermissionStatus";
    public static readonly API_GET_PUBLIC_POSTING_PERMISSION_STATUS: string =
  "v2/getPublicPostingPermissionStatus";
      public static readonly API_GET_CUSTOMER_DETAILS: string =
  "v2/getCustomerDetails";
      public static readonly API_REQUEST_ENTITY_DOMAIN_MAPPING: string =
  "v2/requestEntityDomainMapping"
      public static readonly API_SET_BUSINESS_SOCIAL_LINKS: string =
  "v2/setBusinessSocialLinks";
    public static readonly API_SEND_REVIEW_REQUEST_VIA_EMAIL: string =
  "v2/sendReviewRequestViaEmail";
    public static readonly API_SEND_PAYMENT_INTIMATION_VIA_EMAIL: string =
  "v2/sendPaymentIntimaionViaEmail";
    public static readonly API_SEND_REVIEW_REQUEST_VIA_WHATSAPP: string =
  "v2/sendReviewRequestViaWhatsApp";
    public static readonly API_SEND_PAYMENT_INTIMATION_VIA_WHATSAPP: string =
  "v2/sendPaymentIntimationViaWhatsApp";
      public static readonly API_EDIT_MEMBER_ADDRESS: string =
  "v2/editMemberAddress";
    public static readonly API_EDIT_MEMBER_VIRTUAL_SESSION_INFO: string =
  "v2/editMemberVirtualSessionInfo";

  //----------  API RESPONSE TYPES  ----------//
  public static readonly CHECK_USER_RESULT: string = "checkUserResult";
  public static readonly GET_ALL_USERS_RESULT: string = "getAllUsersResult";
  public static readonly GET_CONTACT_MESSAGES_RESULT: string =
    "getContactMessagesResult";
  public static readonly GET_SUBSCRIPTION_DETAIL_RESULT: string =
    "getSubscriptionDetailResult";
  public static readonly GET_USER_REPORT_REQUEST_RESULT: string =
    "getUserReportRequestResult";
  public static readonly GET_USER_DEACTIVATION_RESULT: string =
    "getUserDeactivationResult";
  public static readonly UPDATE_USER_REQUEST_STATUS_RESULT: string =
    "updateUserRequestStatusResult";
  public static readonly UPDATE_BUISNESS_PROMOTION_INFO_RESULT: string =
    "updateBuisnessPromotionInfoResult";
  public static readonly UPLOAD_RESULT: string = "uploadResult";
  public static readonly GET_BUISNESS_PROMOTION_LIST_RESULT: string =
    "getBuisnessPromotionListResult";
  public static readonly GET_BUISNESS_PROMOTION_LIST_COUNT_RESULT: string =
    "getBuisnessPromotionListCountResult";
  public static readonly GET_ADMIN_POST_LIST_RESULT: string =
    "getAdminPostListResult";
  public static readonly UPDATE_ADMIN_POST_INFO_RESULT: string =
    "updateAdminPostInfoResult";
  public static readonly GET_ADMIN_POST_LIST_COUNT_RESULT: string =
    "getAdminPostListCountResult";
  public static readonly SEND_FCM_NOTIFICATION_TO_TOPIC_RESULT: string =
    "sendFCMNotificationToTopicResult";
  public static readonly GET_TARGETED_NOTIFICATIONS_RESULT: string =
    "getTargetedNotificationListResult";
  public static readonly GET_COUPONS_LIST_RESULT: string =
    "getDiscountCouponsListResult";
  public static readonly GET_COUPONS_LIST_COUNT_RESULT: string =
    "getDiscountCouponsListCountResult";
  public static readonly GET_BANK_INFO_RESULT: string = "getBankInfoResult";
  public static readonly GET_SERVICES_TYPES_LIST_RESULT: string =
    "getServicesTypesListResult";
  public static readonly GET_SERVICES_TYPES_LIST_COUNT_RESULT: string =
    "getServicesTypesListResultResult";
  public static readonly GET_ENTITY_DETAILS_RESULT: string =
    "getEntityDetailstResult";
  public static readonly GET_ALL_ENTITY_DETAILS_RESULT: string =
    "getAllEntityDetailstResult";
  public static readonly GET_ALL_ENTITY_SERVICE_PAYMENTS_RESULT: string =
    "getEntityAllServicePaymentsResult";
  public static readonly GET_ALL_TRANSFERRED_ENTITY_PAYMENT_RESULT: string =
    "getAllTransferredEntityPaymentResult";
  public static readonly GET_BUSINESS_LIST_RESULT: string =
    "getBusinessListResult";
  public static readonly GET_BUSINESS_LIST_COUNT_RESULT: string =
    "getBusinessListCountResult";
  public static readonly GET_BUSINESS_DOCS_LIST_RESULT: string =
    "getBusinessDocsListResult";
  public static readonly CREATE_DISCOUNT_COUPON_RESULT: string =
    "CreateorUpdateCouponStatusResult";
  public static readonly UPDATE_BUSINESS_DOCS_STATUS_RESULT: string =
    "updateBusinessDocsStatusResult";
  public static readonly UPDATE_BANK_INFO_RESULT: string =
    "updateBankInfoResult";
  public static readonly ADD_UPDATE_SERVICE_TYPE_RESULT: string =
    "addUpdateServiceTypeResult";
  public static readonly GET_SERVICE_TEMPLATES_RESULT: string =
    "getServiceTemplatesResult";
  public static readonly ADD_SERVICE_TEMPLATES_RESULT: string =
    "addServiceTemplatesResult";
  public static readonly UPDATE_ENTITY_INFO_RESULT: string =
    "updateEntityInfoResult";
  public static readonly DELETE_ENTITY_INFO_RESULT: string =
    "deleteEntityInfoResult";
  public static readonly GET_BOOKINGS_LIST_RESULT: string =
    "getBookingsListResult";
  public static readonly GET_EMPLOYEE_LIST_RESULT: string =
    "getEmployeeListResult";
  public static readonly GET_USER_DETAIL_RESULT: string = "getUserDetailResult";
  public static readonly GET_USER_DETAIL_RESULT_TO_SET_COOKIE: string = "getUserDetailToSetCookieResult";
  public static readonly GET_POST_DETAIL_RESULT: string = "getPostDetailResult";
  public static readonly ADD_CONTACT_MESSAGES_RESULT: string =
    "addContactMessagesResult";
  public static readonly GET_CITY_SPECIFIC_DATA_RESULT: string =
    "getCitySpecificDataResult";
  public static readonly BLOCK_UNBLOCK_OPERATION_RESULT: string =
    "blockUnblockOperationResult";
  public static readonly GET_REFERRAL_ACTIVITY_RESULT: string =
    "getReferralActivityResult";
  public static readonly UPDATE_REFERRAL_ACTIVITY_STATUS_RESULT: string =
    "updateReferralActivityStatusResult";
  public static readonly GET_REFERRED_USER_DETAILS_RESULT: string =
    "getReferredUserDetailsResult";
  public static readonly GET_LATEST_BLOCKED_UNBLOCKED_ACCOUNTS_RESULT: string =
    "getLatestBlockedUnblockedAccountsResult";
  public static readonly ADD_FREE_SUBSCRIPTION_RESULT: string =
    "addFreeSubscriptionResult";
  public static readonly GET_UNUSED_QR_CODES_RESULT: string =
    "getUnUsedQRCodesResult";
  public static readonly GET_LINKED_QR_CODES_RESULT: string =
    "getLinkedQRCodesResult";
  public static readonly CREATE_QR_CODE_RESULT: string = "createQRcodeResult";
  public static readonly GET_BOOKING_QR_CODES_RESULT: string =
    "getLatestBookingQRCodeResult";
  public static readonly LINK_QR_CODE_RESULT: string = "linkQrcodeResult";
  public static readonly UNLINK_QR_CODE_RESULT: string = "unlinkQrcodeResult";
  public static readonly RESULT_API_GET_CURRENT_STATISTICS: string =
    "getCurrentStatisticsResult";
  public static readonly RESULT_API_GET_APP_DATA_SETTINGS: string =
    "getAppDataSettingsResult";
  public static readonly RESULT_API_GET_ADVERTISERS: string =
    "getAdvertisersResult";
  public static readonly RESULT_API_ADD_EDIT_APP_DATA_SETTINGS: string =
    "addEditAppDataSettingsResult";
  public static readonly RESULT_API_ADD_EDIT_ADVERTISERS: string =
    "addEditAdvertisersResult";
  public static readonly RESULT_API_GET_ADVERTISERS_PROMOTIONAL_POST_CAMPAIGNS: string =
    "getPromotionalPostCampaignsResult";
    public static readonly RESULT_API_CHECK_APP_CURRENT_VERSION: string =
    "checkAppCurrentVersionResult";
  public static readonly RESULT_API_GET_ADVERTISERS_BANNER_CAMPAIGNS: string =
    "getPromotionalBannerCampaignsResult";
  public static readonly RESULT_API_GET_ADVERTISERS_TARGETTED_NOTIFICATION_CAMPAIGNS: string =
    "getTargetedNotificationCampaignsResult";
  public static readonly RESULT_API_GET_ADVERTISERS_PAYMENTS: string =
    "getAdvertiserPaymentsResult";
  public static readonly RESULT_API_SET_ADVERTISERS_PAYMENTS: string =
    "setAdvertiserPaymentsResult";
  public static readonly RESULT_API_GET_FCM_TOPICS: string =
    "getAllFCMTopicResult";
  public static readonly RESULT_API_ADD_EDIT_FCM_TOPIC: string =
    "addEditFCMTopicResult";
  public static readonly RESULT_API_ASSIGN_SUBSCRIBER_TO_FCM_TOPIC: string =
    "assignSubscriberToFCMTopicResult";
  public static readonly RESULT_API_GET_SUBSCRIBER_FROM_FCM_TOPICS: string =
    "getSubscriberFromFCMTopicResult";
  public static readonly RESULT_API_REMOVE_SUBSCRIBER_FROM_FCM_TOPICS: string =
    "removeSubscriberFromFCMTopicResult";
  public static readonly RESULT_API_GET_INVENTORY_ITEMS: string =
    "getInventoryItemsResult";
  public static readonly RESULT_API_ADD_EDIT_INVENTORY_ITEM: string =
    "addEditInventoryItemResult";
  public static readonly RESULT_API_GET_INVENTORY_ITEMS_TEMPLATE_LIST: string =
    "getInventoryItemTemplateListResult";
  public static readonly RESULT_API_ADD_EDIT_INVENTORY_ITEM_TEMPLATE_LIST: string =
    "addEditInventoryItemTemplateDetailsResult";

  //SEARCH
  public static readonly RESULT_API_GET_SERVICE_TEMPLATE_DATA_BY_KEYWORD: string =
    "getServiceTemplateDataByKeywordResult";
  public static readonly RESULT_API_GET_SERVICE_DATA_BY_KEYWORD: string =
    "getServiceDataByKeywordResult";
  public static readonly RESULT_API_GET_INVENTORY_TEMPLATE_DATA_BY_KEYWORD: string =
    "getInventoryTemplateDataByKeywordResult";
  public static readonly RESULT_API_GET_INVENTORY_DATA_BY_KEYWORD: string =
    "getInventoryDataByKeywordResult";

  //APP FUNCTIONALITY
  public static readonly RESULT_API_GET_APP_FUNCTIONALITY_LIST: string =
    "getAppFunctionalityListResult";
  public static readonly RESULT_API_ADD_EDIT_APP_FUNCTIONALITY_LIST: string =
    "addEditAppFunctionalityResult";
  public static readonly RESULT_API_GET_APP_FUNCTIONALITY_BY_ENTITY_ID: string =
    "getFunctionalityByEntityIdResult";
  public static readonly RESULT_API_ADD_EDIT_APP_FUNCTIONALITY_TO_ENTITY: string =
    "addEditFunctionalityToEntityResult";

  //
  public static readonly RESULT_API_GET_ENTITY_SLOTS_INFO: string =
    "getEntitySlotsInfoResult";
  public static readonly RESULT_API_GET_ENTITY_SLOTS_INFO2: string =
    "getEntitySlotsInfoResult2";
  public static readonly RESULT_API_UPDATE_BOOKING_STATUS: string =
    "updateBookingStatusResult";
  public static readonly RESULT_API_UPDATE_BOOKING_STATUS_FOR_NEW_BOOKING: string =
    "updateBookingStatusForNewBookingResult";
  public static readonly RESULT_API_UPDATE_BOOKING_STATUS_WITH_INVOICE: string =
    "updateBookingStatusWithInvoiceResult";
  public static readonly RESULT_API_RESET_BOOKING_DETAILS: string =
    "resetBookingDetailsResult";
  public static readonly RESULT_API_GET_ENTITY_INVOICE_DETAILS: string =
    "getEntityInvoiceDetailsResult";
  public static readonly RESULT_API_ADD_EDIT_ENTITY_INVOICE_DETAILS: string =
    "addEditEntityInvoiceResult";
  public static readonly RESULT_API_GET_BOOKING_OPERATION_DETAILS: string =
    "getBookingOperationDetailsResult";
  public static readonly RESULT_API_CUSTOMISE_BOOKING_DETAILS: string =
    "customizeBookingDetailsResult";

  /**Tax and GST */
  public static readonly RESULT_API_GET_ENTITY_TAX_DATA: string =
    "getEntityTaxDataResult";
  public static readonly RESULT_API_ADD_EDIT_ENTITY_TAX_DATA: string =
    "addEditEntityTaxDataResult";

  public static readonly RESULT_API_GET_ENTITY_BILL_DISCOUNT: string =
    "getBillDiscountResult";
  public static readonly RESULT_API_ADD_EDIT_ENTITY_BILL_DISCOUNT: string =
    "addEditBillDiscountResult";
  public static readonly RESULT_API_GET_SUBSCRIPTION_HISTORY_BY_ID: string =
    "getSubcriptionHistoryByIdResult";

  /** */

  public static readonly RESULT_API_UPDATE_ENTITY_SUBSCRIPTION_INFO: string =
    "updateEntitySubsciptionInfoResult";
  public static readonly RESULT_API_GET_PLANS_LIST: string =
    "getPlansListResult";
  public static readonly RESULT_API_CREATE_SUBSCRIPTION_ORDER: string =
    "createSubscriptionOrderResult";
  public static readonly RESULT_API_VALIDATE_PAYMENT_SIGNATURE: string =
    "validatePaymentSignatureResult";
  public static readonly RESULT_API_UPDATE_PAYMENT_RECORD: string =
    "updatePaymentRecordResult";
  public static readonly RESULT_API_GET_SHOP_SERVICE_TIMINGS: string =
    "getEntityTimeDetailsResult";
  public static readonly RESULT_API_GET_HOME_SERVICE_TIMINGS: string =
    "getHomeSeviceTimeDetailsResult";
  public static readonly RESULT_API_UPDATE_ENTITY_SHOP_SERVICE_TIMINGS: string =
    "updateEntityTimeInfoResult";
  public static readonly RESULT_API_UPDATE_ENTITY_HOME_SERVICE_TIMINGS: string =
    "updateHomeServiceTimeInfoResult";
  public static readonly RESULT_API_UPDATE_FCM_TOKEN_INFO: string =
    "updateFcmTokenInfoResult";
  public static readonly RESULT_API_GET_NOTIFICATIONS: string =
    "getNotificationsResult";
  public static readonly RESULT_API_GET_FEEDBACKS: string =
    "getFeedBacksResult";
  public static readonly RESULT_API_GET_BOOKING_QR: string =
    "getLatestBookingQRCodeResult";
  public static readonly RESULT_API_CREATE_BOOKING_QR: string =
    "createBookingQRCodeResult";
  public static readonly RESULT_API_UPDATE_USER_PROFILE: string =
    "updateUserProfileResult";
  public static readonly RESULT_API_GET_ENTITY_ACTIVE_SUBSCRIPTION: string =
    "getEntityActiveSubscriptionResult";
  public static readonly RESULT_API_GET_EMPLOYEE_REQUEST_LIST: string =
    "getEmployeeRequestListResult";
  public static readonly RESULT_API_SEND_EMPLOYEE_REQUEST: string =
    "sendEmployeeRequestResult";
  public static readonly RESULT_API_GET_SALARY_INFO: string =
    "getSalaryInfoResult";
  public static readonly RESULT_API_GET_SALARY_INFO_ONLY: string =
    "getSalaryInfoResultOnly";
  public static readonly RESULT_API_UPDATE_SALARY_INFO: string =
    "updateSalaryInfoResult";
  public static readonly RESULT_API_GET_USER_EXPENSES_LIST: string =
    "getUserExpensesListResult";
  public static readonly RESULT_API_UPDATE_USER_EXPENSES_INFO: string =
    "updateUserExpenseInfoResult";
  public static readonly RESULT_API_UPDATE_USER_SUBSCRIPTION_INFO: string =
    "updateUserSubsciptionInfoResult";
  public static readonly RESULT_API_GET_TRANSACTIONS_LIST: string =
    "getTransactionsListResult";
  public static readonly RESULT_API_GET_EMPLOYEE_SUBSCRIPTION_INFO: string =
    "getEmployeeSubscriptionInfoResult";
  public static readonly RESULT_API_GET_EMPLOYEE_DUTY_LOG: string =
    "getEmployeeDutyLogResult";
  public static readonly RESULT_API_ADD_AS_EMPLOYEE: string =
    "addAsEmployeeResult";
  public static readonly RESULT_API_UPDATE_EMPLOYEE_INFO: string =
    "updateEmployeeInfoResult";
  public static readonly RESULT_API_RESET_INVOICE_DATA: string =
    "resetInvoiceDataResult";
  public static readonly RESULT_API_ADD_EDIT_PAYMENT_RECORD: string =
    "addEditPaymentRecordResult";
  public static readonly RESULT_API_CONTACT_US: string = "contactUsResult";
  public static readonly RESULT_API_GET_CUSTOMERS_BY_ENTITY_ID: string =
    "getCustomersByEntityIdResult";
  public static readonly RESULT_API_GET_CUSTOMERS_WITH_DUES_BY_ENTITY_ID: string =
    "getCustomersWithDuesByEntityIdResult";
  public static readonly RESULT_API_GET_LONG_ABSENT_CUSTOMERS_BY_ENTITY_ID: string =
    "getLongAbsentCustomersByEntityIdResult";
  public static readonly RESULT_API_GET_ENTITY_CUSTOMER_BOOKING_HISTORY: string =
    "getEntityCustomerBookingHistoryResult";
  public static readonly RESULT_API_GET_ENTITY_CUSTOMER_DUE_BOOKING_HISTORY: string =
    "getEntityCustomerDueBookingListResult";
  public static readonly RESULT_API_GET_BOOKING_DETAIL_BY_ID: string =
    "getBookingDetailByIdResult";
  public static readonly RESULT_API_GET_CUSTOMER_BY_SEARCH: string =
    "getCustomerDataByKeywordResult";
  public static readonly RESULT_API_SET_NOTIFICATION_PRIVACY: string =
    "setNotificationPrivacyResult";
  public static readonly RESULT_API_SET_REQUEST: string = "setRequestResult";
  public static readonly RESULT_API_GET_MESSAGES_BY_ID: string =
    "getMessagesByIDResult";
  public static readonly RESULT_API_GET_MESSAGES_BY_ID_FOR_EMPLOYEE: string =
    "getMessagesByIDResultForEmployee";
  public static readonly RESULT_API_GET_SUB_MESSAGES_BY_ID: string =
    "getSubMessagesByIDResult";
  public static readonly RESULT_API_UPDATE_MESSAGE_THREAD: string =
    "updateMessageThreadResult";
  public static readonly RESULT_API_GET_ENTITY_INVENTORY_IN_OUT_DATA: string =
    "getEntityInventoryInOutDataResult";
  public static readonly RESULT_API_GET_ENTITY_INVENTORY_ITEMS: string =
    "getInventoryItemsResult";
  public static readonly RESULT_API_SET_INVENTORY_ITEM_ACTIVITY: string =
    "setInventoryItemActivityResult";
  public static readonly RESULT_API_EDIT_INVENTORY_ACTIVITY: string =
    "editInventoryActivityResult";
  public static readonly RESULT_API_ENTITY_PURCHASE_ITEMS: string =
    "getEntityPurchaseItemsResult";
  public static readonly RESULT_API_ENTITY_PURCHASE_OVERVIEW: string =
    "getEntityPurchaseOverviewResult";
  public static readonly RESULT_API_ENTITY_EXPENSES_OVERVIEW: string =
    "getEntityExpenseOverviewResult";
  public static readonly RESULT_API_ADD_EDIT_PURCHASE_ITEM: string =
    "addEditPurchaseItemResult";
  public static readonly RESULT_API_GET_EXPENSES_LIST: string =
    "getExpensesListResult";
  public static readonly RESULT_API_UPDATE_EXPENSE_INFO: string =
    "updateExpenseInfoResult";
  public static readonly RESULT_API_UPDATE_MESSAGE: string =
    "updateMessageResult";
  public static readonly RESULT_API_SEND_UNBLOCK_REQUEST: string =
    "sendUnblockRequestResult";
  public static readonly RESULT_API_GET_ENTITY_SERVICE_TEMPLATES: string =
    "getEntityServiceTemplatesResult";
  public static readonly RESULT_API_UPDATE_VIRTUAL_SERVICE_TIMINGS: string =
    "updateVirtualServiceTimingInfoResult";
  public static readonly RESULT_API_GET_ENROLL_INTEREST_BY_ENTITY_ID: string =
    "getAllEnrollInterestByEntityIdResult";
        public static readonly RESULT_API_GET_ENTITY_FAVOURITES_LIST: string =
    "getEntityFavouritesListResult";
      public static readonly RESULT_API_SET_REWARD_POINT_CONVERSION_FOR_ENTITY: string =
    "setRewardPountConversionForEntityResult";
    public static readonly RESULT_API_GET_REWARD_POINT_CONVERSION_FOR_ENTITY: string =
    "getRewardPountConversionForEntityResult";
     public static readonly RESULT_API_GET_USER_TOTAL_REWARD_AMOUNT_FOR_ENTITY: string =
    "getUserTotalRewardAmountForEntityResult";
    public static readonly RESULT_API_GET_USER_REWARD_TRANSACTION_LIST_FOR_ENTITY: string =
    "getUserRewardTransactionsListForEntityResult";

  // ------------------ REPORT APIS RESULT TYPES ------------------
  public static readonly RESULT_API_GET_SALES_REPORT: string =
    "getSalesReportResult";
  public static readonly RESULT_API_GET_EMPLOYEE_SALES_REPORT: string =
    "getEmployeeSalesReportResult";
  public static readonly RESULT_API_GET_EXPENDITURE_REPORT: string =
    "getExpenditureReportResult";
  public static readonly RESULT_API_GET_EMPLOYEE_SALARY_REPORT: string =
    "EmployeeSalaryReportResult";
  public static readonly RESULT_API_GET_BOOKING_REPORT: string =
    "getBookingReportResult";
  public static readonly RESULT_API_GET_SERVICE_REPORT: string =
    "getServiceReportResult";
  public static readonly RESULT_API_GET_INVOICE_REPORT: string =
    "getInvoiceReportResult";
  public static readonly RESULT_API_GET_PAYMENT_REPORT: string =
    "getEntityServicePaymentsForTransferResult";
  public static readonly RESULT_API_GET_INVENTORY_ACTIVITY_REPORT: string =
    "getInventoryActivityReportResult";
  public static readonly RESULT_API_GET_PURCHASE_REPORT: string =
    "getPurchaseReportResult";
        public static readonly RESULT_API_GET_INTERNATIONAL_ENTITY_ALL_SERVICE_PAYMENT: string =
    "getInternationalEntityAllServicePaymentsResult";
  public static readonly RESULT_API_GET_REVENUE_INSIGHT_REPORT: string =
    "getRevenueInsightReportResult";
  public static readonly RESULT_API_GET_TAX_COLLECTION_REPORT: string =
    "getTaxCollectionReportResult";
  public static readonly RESULT_API_GET_ENTITY_FOLLOWING_LIST: string =
    "getEntityFollowingListResult";
  public static readonly RESULT_API_GET_POSTS_AS_PER_ID: string =
    "getPostsAsPerIDResult";
  public static readonly RESULT_API_GET_ALL_ASSETS_AS_PER_ID: string =
    "getAllAssetsAsPerIDResult";
  public static readonly RESULT_API_GET_FEED_AS_PER_BUSINESS_ID: string =
    "getFeedAsPerBusinessIDResult";
  public static readonly RESULT_API_ENABLE_ONLINE_PAYMENTS: string =
    "enableOnlinePaymentsResult";
  public static readonly RESULT_API_GENERATE_INVOICE_PDF: string =
    "generateInvoicePDFResult";
  public static readonly RESULT_API_GET_ENTITY_SPECIFIC_SUPPORT_TICKETS: string =
    "getEntitySpecificSupportTicketsResult";
  public static readonly RESULT_API_GET_SUPPORT_THREAD: string =
    "getSupportThreadResult";
  public static readonly RESULT_API_CREATE_SUPPORT_TICKET: string =
    "createSupportTicketResult";
  public static readonly RESULT_API_CREATE_SUPPORT_TICKET_RESPONSE: string =
    "createSupportTicketResponseResult";
  public static readonly RESULT_API_SET_SUPPORT_TICKET_STATUS: string =
    "setSupportTicketStatusResult";

    public static readonly RESULT_API_GET_TODAY_BOOKINGS_FOR_DASHBOARD: string =
    "resultgetTodaysBookingsForDashboard";
    public static readonly RESULT_API_GET_TODAY_BOOKINGS_FOR_DASHBOARD_COUNT: string =
    "resultgetTodaysBookingsForDashboardCount";

    public static readonly RESULT_API_GET_UPCOMING_BOOKINGS_FOR_DASHBOARD: string =
    "resultgetUpcomingBookingsForDashboard";
    public static readonly RESULT_API_GET_UPCOMING_BOOKINGS_FOR_DASHBOARD_COUNT: string =
    "resultgetUpcomingBookingsForDashboardCount";

    public static readonly RESULT_API_GET_LATEST_PURCHASES_FOR_DASHBOARD: string =
    "resultgetLatestPurchasesForDashboard";
    public static readonly RESULT_API_GET_LATEST_PURCHASES_FOR_DASHBOARD_COUNT: string =
    "resultgetLatestPurchasesForDashboardCount";
  
    public static readonly RESULT_API_GET_LATEST_INVENTORY_STATUS_FOR_DASHBOARD: string =
    "resultgetLatestInventoryStatusForDashboard";
    public static readonly RESULT_API_GET_LATEST_INVENTORY_STATUS_FOR_DASHBOARD_COUNT: string =
    "resultgetLatestInventoryStatusForDashboardCount";
  
    public static readonly RESULT_API_GET_LATEST_EXPENSES_FOR_DASHBOARD: string =
    "resultgetLatestExpensesForDashboard";
    public static readonly RESULT_API_GET_LATEST_EXPENSES_FOR_DASHBOARD_COUNT: string =
    "resultgetLatestExpensesForDashboardCount";
  
    public static readonly RESULT_API_GET_TODAYS_EMPLOYEE_LOG_FOR_DASHBOARD: string =
    "resultgetTodaysEmployeeLogForDashboard";
    public static readonly RESULT_API_GET_TODAYS_EMPLOYEE_LOG_FOR_DASHBOARD_COUNT: string =
    "resultgetTodaysEmployeeLogForDashboardCount";
  
  
  
    public static readonly RESULT_API_GET_COMPOSITE_SALES_DATA_FOR_DASHBOARD: string =
    "resultgetCompositeSalesDataForDashboard";
  public static readonly RESULT_API_GET_COMPOSITE_BOOKING_DATA_FOR_DASHBOARD: string =
    "resultgetCompositeBookingDataForDashboard";
  public static readonly RESULT_API_GET_COMPOSITE_EXPENDITURE_DATA_FOR_DASHBOARD: string =
    "resultgetCompositeExpenditureDataForDashboard";
  public static readonly RESULT_API_GET_ENTITY_FEATURE_WISE_COUNTS: string =
    "resultgetEntityFeatureWiseCounts";
  public static readonly RESULT_API_UPDATE_ENTITY_SERVICES: string =
    "resultupdateEntityServices";
  public static readonly RESULT_API_UPDATE_ENTITY_DETAILS: string =
    "resultupdateEntityDetails";
  public static readonly RESULT_API_UPLOAD_ENTITY_MEDIA: string =
    "resultuploadEntityMedia";
  public static readonly RESULT_API_UPDATE_ENTITY_LOCATION: string =
    "resultupdateEntityLocation";
  public static readonly RESULT_API_DEACTIVATE_ENTITY: string =
    "resultdeactivateEntity";
  public static readonly RESULT_API_SET_MEDIA_AS_DEFAULT: string =
    "resultsetMediaAsDefault";
  public static readonly RESULT_API_DELETE_UPLOADED_MEDIA: string =
    "resultdeleteUploadedMedia";
  public static readonly RESULT_API_GET_BASIC_ENTITY_LIST: string =
    "resultgetBasicEntityList";
  public static readonly RESULT_API_GET_EMPLOYEE_DETAILS: string =
    "resultgetEmployeeDetails";
  public static readonly RESULT_API_GET_EMPLOYEE_FEATURE_WISE_COUNT: string =
    "resultgetEmployeeFeatureWiseCounts";
  public static readonly RESULT_API_SET_NOTIFICATION_READ_STATUS: string =
    "resultsetNotificationReadStatus";
  public static readonly RESULT_API_GET_ENTITY_DISCOUNT: string =
    "resultgetBillDiscountData";
    
    public static readonly RESULT_API_SEND_EMAIL: string =
    "sendEmailResult";
  public static readonly RESULT_API_SEND_WHATSAPP: string =
    "sendWhatsAppMessageResult";
  public static readonly RESULT_API_GET_VIRTUAL_SERVICE_TIMINGS: string =
    "getVirtualServiceTimingsResult";
  public static readonly RESULT_API_DELETE_ENTITY_BY_OWNER: string =
    "deleteEntityByOwnerResult";
  public static readonly RESULT_API_SET_EMPLOYEE_ACTIVATION_STATUS: string =
    "setEmployeeActivationStatusResult";
  public static readonly RESULT_API_GET_ENTITY_INVENTORY_STATUS: string =
    "getEntityInventoryStatusResult";
  public static readonly RESULT_API_ADD_EDIT_ENROLL_INTEREST_BY_ENTITY: string =
    "addEditEnrollInterestByEntityResult";
  public static readonly RESULT_API_GET_ENROLL_INTEREST_DETAILS_BY_ID: string =
    "getEnrollInterestDetailsByIdResult";
  public static readonly RESULT_API_UPDATE_ENROLL_PROGRESS_STATUS: string =
    "updateEnrollInterestProgressStatusResult";
  public static readonly RESULT_API_UPDATE_ENROLL_STATUS: string =
    "updateEnrollInterestStatusResult";
  public static readonly RESULT_API_GET_FITNESS_AUTOCORRECT: string =
    "getFitnessEnrolledMemberForAutoCorrectResult";
  public static readonly RESULT_API_GET_SEARCH_BY_ENROLL_INTEREST: string =
    "getSearchByEnrollInterestResult";
  public static readonly RESULT_API_GET_ENROLL_MEMBERS_SEARCH_BY_TYPE: string =
    "getEnrolledMembersListByTypeResult";
  public static readonly RESULT_API_ADD_EDIT_ENROLL_MEMBERS: string =
    "addEdiEnrolledMemberResult";
  public static readonly RESULT_API_ADD_EDIT_FITNESS_ENTITY_INVOICE: string =
    "addEditFitnessEntityInvoiceResult";
  public static readonly RESULT_API_GET_MEMBER_INVOICE_DETAILS: string =
    "getMemberInvoiceDetailsResult";
  public static readonly RESULT_API_GET_ENROLLED_MEMBER_DETAILS: string =
    "getEnrolledMemberDetailsResult";
  public static readonly RESULT_API_GET_ENTITY_MEMBER_ALL_INVOICE_LIST: string =
    "getEntityMembersAllInvoiceListResult";
  public static readonly RESULT_API_GET_ENTITY_MEMBER_DUE_INVOICE_LIST: string =
    "getEntityMemberDueInvoiceListResult";
  public static readonly RESULT_API_UPDATE_ENROLLED_MEMBER_MEMBERSHIP_STATUS: string =
    "updateEnrolledMemberMembershipStatusResult";
  public static readonly RESULT_API_ADD_EDIT_CUSTOMER_BY_ENTITY: string =
    "addEditCustomerByEntityResult";
  public static readonly RESULT_API_DELETE_ENTITY_APPOINTMENT_DATA: string =
    "deleteEntityAppointmentDataResult";
  public static readonly RESULT_API_DELETE_ENTITY_CUSTOMER_DATA: string =
    "deleteEntityCustomerResult";
  public static readonly RESULT_API_DELETE_ENTITY_MEMBER_DATA: string =
    "deleteEntityMemberResult";
  public static readonly RESULT_API_DELETE_ENTITY_REQUEST_DATA: string =
    "deleteEntityRequestDataResult";
  public static readonly RESULT_API_RECORD_FITNESS_INVOICE: string =
    "addEditFitnessInvoicePaymentRecordResult";
  public static readonly RESULT_API_DELETE_ENTITY_INVOICE: string =
    "deleteEntityInvoiceResult";
  public static readonly RESULT_API_SEND_INVOICE_EMAIL: string =
    "sendInvoiceViaEmailResult";
  public static readonly RESULT_API_GET_INTERNATIONAL_ENTITY_TAX_DATA: string =
    "getInternationalEntityTaxDataResult";
  public static readonly RESULT_API_ADD_EDIT_INTERNATIONAL_ENTITY_TAX_DATA: string =
    "addEditInternationalEntityTaxDataResult";
  public static readonly RESULT_API_GET_INTERNATIONAL_ENTITY_INVOICE_DETAILS: string =
    "getInternationalEntityInvoiceDetailsResult";
  public static readonly RESULT_API_ADD_EDIT_INTERNATIONAL_ENTITY_INVOICE: string =
    "addEditInternationalEntityInvoiceResult";
  public static readonly RESULT_API_ADD_EDIT_INTERNATIONAL_FITNESS_ENTITY_INVOICE: string =
    "addEditInternationalFitnessEntityInvoiceResult";
  public static readonly RESULT_API_GET_INTERNATIONAL_FITNESS_ENTITY_INVOICE_DETAILS: string =
    "getInternationalFitnessEntityInvoiceDetailsResult";
  public static readonly RESULT_API_GET_INTERNATIONAL_ENTITY_INVOICE_LIST_FOR_REPORTS: string =
    "getInternationalEntityInvoiceListForReportsResult";
  public static readonly RESULT_API_GET_INTERNATIONAL_ENTITY_TAX_COLLECTION_REPORT: string =
    "getInternationalTaxCollectionReportResult";
  public static readonly RESULT_API_GET_INTERNATIONAL_SALES_REPORT: string =
    "getInternationalSalesReportResult";
  public static readonly RESULT_API_GET_INTERNATIONAL_REVENUE_INSIGHT_REPORT: string =
    "getInternationalRevenueInsightReportResult";
  public static readonly RESULT_API_ADD_EDIT_INTERNATIONAL_INVOICE_PAYMENT_RECORD: string =
    "addEditInternationInvoicePaymentRecordResult";
  public static readonly RESULT_API_ADD_EDIT_FITNESS_INTERNATIONAL_INVOICE_PAYMENT_RECORD: string =
    "addEditFitnessInternationalInvoicePaymentRecordResult";
  public static readonly RESULT_API_DELETE_INTERNATIONAL_INVOICE_DETAILS: string =
    "deleteInternationalInvoiceDetailsResult";
  public static readonly RESULT_API_GENERATE_INTERNATIONAL_INVOICE_PDF: string =
    "generateInternationalInvoicePDFResult";
  public static readonly RESULT_API_ADD_EDIT_INTERNATIONAL_ENTITY_TAX_CONFIGURATION: string =
    "addEditInternationalEntityTaxConfigurationResult";
  public static readonly RESULT_API_SEND_INTERNATIONAL_INVOICE_EMAIL: string =
    "sendInternationalInvoiceViaEmailResult";
  public static readonly RESULT_API_GET_ENTITY_TAX_SLAB_DATA: string =
    "getEntityTaxSlabDataResult";
  public static readonly RESULT_API_ADD_ENTITY_PRIMARY_TAX_DATA: string =
    "addEditEntityPrimaryTaxDataResult";
  public static readonly RESULT_API_GET_INTERNATIONAL_ENTITY_TAX_SLAB_DATA: string =
    "getInternationalEntityTaxSlabsDataResult";
  public static readonly RESULT_API_ADD_EDIT_INTERNATIONAL_ENTITY_TAX_SLABS_DATA: string =
    "addEditInternationalEntityTaxSlabsDataResult";
  public static readonly RESULT_API_DELETE_ENTITY_TAX_SLAB_DATA: string =
    "deleteEntityTaxSlabDataResult";
  public static readonly RESULT_API_DELETE_INTERNATIONAL_ENTITY_TAX_SLAB_DATA: string =
    "deleteInternationalEntityTaxSlabDataResult";
  public static readonly RESULT_API_ADD_EDIT_ENTITY_PRODUCT: string =
    "addEditEntityProductResult";
  public static readonly RESULT_API_DELETE_ENTITY_PRODUCT: string =
    "deleteEntityProductResult";
  public static readonly RESULT_API_GET_ENTITY_PRODUCT_LIST: string =
    "getEntityProductListResult";
  public static readonly RESULT_API_GET_PRODUCT_DATA_BY_KEYWORD: string =
    "getProductDataByKeywodResult";
  public static readonly RESULT_API_ADD_EDIT_ENTITY_INVOICE_WITHOUT_BOOKING: string =
    "addEditEntityInvoiceWithoutBookingResult";
  public static readonly RESULT_API_ADD_EDIT_INTERNATIONAL_ENTITY_INVOICE_WITHOUT_BOOKING: string =
    "addEditInternationalEntityInvoiceWithoutBookingResult";
  public static readonly RESULT_API_GET_BOOKINGS_FOR_FITNESS_ENTITY: string =
    "getBookingsForFitnessEntityResult";
  public static readonly RESULT_API_GET_HISTORIC_BOOKING_LIST_FOR_FITNESS_ENTITY: string =
    "getHistoricBookingListForFitnessEntityResult";
  public static readonly RESULT_API_GET_HISTORIC_ATTENDANCE_LIST_FOR_FITNESS_ENTITY: string =
    "getHistoricAttendanceListForFitnessEntityResult";
  public static readonly RESULT_API_MARK_MEMBER_ATTENDANCE_STATUS: string =
    "markMemberAttendanceStatusResult";
  public static readonly RESULT_API_GET_MEMBERSHIP_REPORT: string =
    "getMembershipReportResult";
  public static readonly RESULT_API_GET_ACCOUNT_DATA_BY_PHONE_NUMBER: string =
    "getAccountDataByPhoneNumberResult";
  public static readonly RESULT_API_GET_MEMBER_ATTENDANCE_BY_ENTITY: string =
    "getMemberAttendanceByEntityResult";
  public static readonly RESULT_API_MARK_MEMBER_ABSENT_BY_ENTITY: string =
    "markMemberAbsentByEntityResult";
  public static readonly RESULT_API_SET_ENROLLED_MEMBER_PHONE_NUMBER: string =
    "setEnrolledMemberPhoneNumberResult";
  public static readonly RESULT_API_DELETE_MEMBER_ATTENDANCE_DATA_BY_ENTITY: string =
    "deleteMemberAttendanceDataByEntityResult";
  public static readonly RESULT_API_GET_MESSAGE_NOTIFICATION_STATUS: string =
    "getMessageNotificationStatusResult";
  public static readonly RESULT_API_SET_MESSAGE_READ_STATUS: string =
    "setMessageReadStatusResult";
  public static readonly RESULT_API_GET_ENTITY_CUSTOMER_PAYMENT_HISTORY: string =
    "getEntityCustomerPaymentHistoryResult";
  public static readonly RESULT_API_GET_MEMBER_DATA_BY_KEYWORD: string =
    "getMemberDataByKeywordResult";
  public static readonly RESULT_API_UPDATE_POST_INFO: string =
    "updatePostInfoResult";
  public static readonly RESULT_API_SET_EMPLOYEE_DUTY_DATA: string =
    "setEmployeeDutyDataResult";
  public static readonly RESULT_API_GET_JOB_INVITATIONS: string =
    "getJobInvitationsResult";
  public static readonly RESULT_API_GET_EMPLOYER_LIST: string =
    "getEmployerListResult";
  public static readonly RESULT_API_GET_COUNTRY_DATA: string =
    "getCountryDataResult";
  public static readonly RESULT_API_GET_JOB_INVITATION_DETAILS: string =
    "getJobInvitationDetailsResult";
  public static readonly RESULT_API_ASSIGN_EMPLOYEE_TO_MEMBER: string =
    "assignEmployeeToMemberResult";
  public static readonly RESULT_API_UPDATE_MEMBER_SESSION: string =
    "UpdateMemberSessionResult";
  public static readonly RESULT_API_DELETE_LINKED_BANK_ACCOUNT: string =
    "deleteLinkedBankAccountResult";
  public static readonly RESULT_API_LINK_ENTITY_BANK_ACCOUNT: string =
    "linkEntityBankAccountResult";
  public static readonly RESULT_API_GET_ASSIGNED_TASK_COUNT_FOR_DASHBOARD: string =
    "getAssignedTaskCountForDashboardResult";
  public static readonly RESULT_API_GET_UNAVAILABILITY_LIST_OF_ENTITY: string =
    "getUnavailabilityListOfEntityResult";
  public static readonly RESULT_API_SET_UNAVAILABILITY_FOR_ENTITY: string =
    "setUnavailabilityForEntityResult";
  public static readonly RESULT_API_REMOVE_UNAVAILABILITY_FOR_ENTITY: string =
    "removeUnavailabilityForEntityResult";
  public static readonly RESULT_API_GET_SERVICE_PAYMENT_LINK_FOR_ENTITY_INVOICE: string =
    "getServicePaymentLinkForEntityInvoiceResult";
    public static readonly RESULT_API_GET_CUSTOMER_LIST_FOR_AUTOCOMPLETE: string =
    "getCustomerListForAutoCompleteResult";
    public static readonly RESULT_API_UNLINK_BANK_ACCOUNT_FROM_BUSINESS: string =
    "unlinkBankAccountFromBusinessResult";
    public static readonly RESULT_API_GET_ASSIGNED_TASK_LIST_FOR_DASHBOARD: string =
    "getAssignedTaskListByUserResult";
    public static readonly RESULT_API_GET_COMPLETED_TASK_LIST_FOR_DASHBOARD: string =
    "getCompletedTaskListByUserResult";
    public static readonly RESULT_API_UPDATE_VIRTUAL_MEETING_DATA: string =
    "updateVirtualMeetingDetailsResult";
    public static readonly RESULT_API_UPDATE_BOOKING_NOTE: string =
    "updateBookingNoteResult";
    public static readonly RESULT_API_RECORD_PURCHASE_PAYMENT: string =
    "recordPurchasePaymentResult";
    public static readonly RESULT_API_SEND_EMAIL_VERIFICATION_LINK: string =
    "recordPurchasePaymentResult";
    public static readonly RESULT_API_GET_MEMBER_SESSION_DETAILS: string =
    "getMemberSessionDetailsResult";
    public static readonly RESULT_API_GET_ENTITY_WHATSAPP_CAMPAIGN_LIST: string =
    "getEntityExternalCampaignListResult";
    public static readonly RESULT_API_GET_ENTITY_WHATSAPP_CAMPAIGN_TARGETS: string =
    "getEntityWhatsAppCampaignTargetsResult";
    public static readonly RESULT_API_ADD_EDIT_ENTITY_WHATSAPP_CAMPAIGN: string =
    "addEditEntityExternalCampaignResult";
    public static readonly RESULT_API_DELETE_ENTITY_WHATSAPP_CAMPAIGN: string =
    "deleteEntityExternalCampaignResult";
        public static readonly RESULT_API_GET_EMPLOYEE_LIST_WITH_ASSIGNMENT: string =
    "getEmployeeListWithAssignmentResult";
     public static readonly RESULT_API_GET_INTERNATIONAL_ENTITY_BANK_INFO: string =
    "getInternationalEntityBankInfoResult";
    public static readonly RESULT_API_ENABLE_INTERNATIONAL_ONLINE_PAYMENTS: string =
    "enableInternationalOnlinePaymentsResult";
    public static readonly RESULT_API_CREATE_PAYPAL_PARTNER_ACCOUNT: string =
    "createPaypalPartnerAccountResult";
    public static readonly RESULT_API_UPDATE_PAYPAL_SELLER_ACCOUNT_DETAILS: string =
    "updatePaypalSellerAccountDetailsResult";
    public static readonly RESULT_API_LINK_INTERNATIONAL_ENTITY_BANK_ACCOUNT: string =
    "linkInternationalEntityBankAccountResult";
    public static readonly RESULT_API_UNLINK_INTERNATIONAL_ENTITY_BANK_ACCOUNT: string =
    "unlinkBankAccountFromInternationalBusinessResult";
        public static readonly RESULT_API_SYNC_LATEST_PAYPAL_DATA: string =
    "syncLatestPayPalDataResult";
      public static readonly RESULT_API_GET_POST_CREATE_ELIGIBILITY: string =
    "getPostCreateEligibilityResult";
       public static readonly RESULT_API_GET_PROGRESS_TRACKERS_FOR_MEMBER: string =
    "getProgressTrackersForMemberResult";
    public static readonly RESULT_API_ADD_EDIT_PROGRESS_TRACKER: string =
    "addEditProgressTrackerResult";
    public static readonly RESULT_API_ADD_EDIT_PROGRESS_DATA: string =
    "addEditProgressDataResult";
    public static readonly RESULT_API_GET_PROGRESS_DATA_BY_TRACKER: string =
    "getProgressDataByTrackerResult";
        public static readonly RESULT_API_CREATE_RAZORPAY_SUB_MERCHANT_ACCOUNT: string =
    "createRazorPaySubMerchantAccountResult";
    public static readonly RESULT_API_UPDATE_RAZORPAY_SUB_MERCHANT_ACCOUNT_DETAILS: string =
    "updateRazorPaySubMerchantAccountDetailsResult";
      public static readonly RESULT_API_LINK_DOMESTIC_ENTITY_BANK_ACCOUNT: string =
    "linkDomesticEntityBankAccountResult";
    public static readonly RESULT_API_GET_DOMESTIC_ENTITY_BANK_INFO: string =
    "getDomesticEntityBankInfoResult";

    public static readonly RESULT_API_GET_ALL_ENROLL_OPEN_INTEREST_BY_ENTITY_ID: string =
    "getAllEnrollOpenInterestByEntityIdResult";
        public static readonly RESULT_API_GET_WHATSAPP_EMAIL_QUOTA_USAGE: string =
    "getWhatsAppEmailQuotaAndUsageResult";

      public static readonly RESULT_API_GET_MEMBER_AUTO_INVOICE_SENDING_SETTINGS: string =
    "getMemberAutoInvoiceSendingSettingsResult";
    public static readonly RESULT_API_SET_MEMBER_AUTO_INVOICE_SENDING_SETTINGS: string =
    "setMemberAutoInvoiceSendingSettingsResult";
        public static readonly RESULT_API_GET_FUNCTIONALITY_BY_EMPLOYEE_ID: string =
    "getFunctionalityByEmployeeIdResult";
    public static readonly RESULT_API_UPDATE_EMPLOYEE_FUNCTIONALITY_ACCESS_STATUS: string =
    "updateEmployeeFunctionalityAccessStatusResult";
       public static readonly RESULT_API_GET_BOOKING_ADVANCE_PAYMENT_SETTINGS: string =
    "getBookingAdvancePaymentSettingsResult";
    public static readonly RESULT_API_SET_BOOKING_ADVANCE_PAYMENT_SETTINGS: string =
    "setBookingAdvancePaymentSettingsResult";
      public static readonly RESULT_API_ADD_EDIT_ENTITY_ADVANCE_INVOICE: string =
    "addEditEntityAdvanceInvoiceResult";
      public static readonly RESULT_API_ADD_EDIT_INTERNATIONAL_ENTITY_ADVANCE_INVOICE: string =
    "addEditInternationalEntityAdvanceInvoiceResult";
      public static readonly RESULT_API_CANCEL_ENTITY_APPOINTMENT_DATA: string =
    "cancelEntityAppointmentDataResult";
    public static readonly RESULT_API_GET_USER_TOTAL_WALLET_AMOUNT_FOR_ENTITY: string =
    "getUserTotalWalletAmountForEntityResult";
    public static readonly RESULT_API_GET_USER_WALLET_TRANSACTIONS_LIST_FOR_ENTITY: string =
    "getUserWalletTransactionsListForEntityResult";
    public static readonly RESULT_API_ADD_TRANSACTION_TO_WALLET: string =
    "addTransactionToWalletResult";
    public static readonly RESULT_API_UPDATE_WALLET_REFUND_STATUS: string =
    "updateWalletRefundStatusResult";
    public static readonly RESULT_API_DELETE_WALLET_TRANSACTION: string =
    "deleteWalletTransactionResult";
    public static readonly RESULT_API_UPDATE_ENTITY_ENQUIRY_PROGRESS_STATUS: string =
    "updateEnityEnquiryProgressStatusResult";
    public static readonly RESULT_API_GET_ENTITY_ENQUIRY_DETAILS: string =
    "getEntityEnquiryDetailsResult";
    public static readonly RESULT_API_GET_ENTITY_ENQUIRY_LIST: string =
    "getEntityEnquiryListResult";
       public static readonly RESULT_API_EDIT_MEMBER_SERVICE_PRODUCT_OTHER_DATA: string =
    "editMemberServiceProductOtherDataResult";
    public static readonly RESULT_API_EDIT_MEMBER_PERSONAL_DETAILS: string =
    "editMemberPersonalDetailsResult";
    public static readonly RESULT_API_EDIT_MEMBER_TIMINGS_DATA: string =
    "editMemberTimingsDataResult";
        public static readonly RESULT_API_GET_ENTITY_ALL_ENQUIRY_LIST: string =
    "getEntityAllEnquiryListResult";
       public static readonly RESULT_API_SET_ENTITY_LOYALTY_CONFIGURATION: string =
    "setEntityLoyaltyConfigurationResult";
    public static readonly RESULT_API_SET_ENTITY_BOOKING_LOYALTY_CONFIGURATION: string =
    "setEntityBookingLoyaltyConfigurationResult";
    public static readonly RESULT_API_SET_ENTITY_PAYMENT_LOYALTY_CONFIGURATION: string =
    "setEntityPaymentLoyaltyConfigurationResult";
    public static readonly RESULT_API_SET_ENTITY_REFERRAL_LOYALTY_CONFIGURATION: string =
    "setEntityReferralLoyaltyConfigurationResult";
    public static readonly RESULT_API_GET_ENTITY_LOYALTY_CONFIGURATION: string =
    "getEntityLoyaltyConfigurationResult";
      public static readonly RESULT_API_REFUND_PAYMENT_TO_CUSTOMER: string =
    "refundPaymentToCustomerResult";

    public static readonly RESULT_API_SET_ENTITY_MEMBERSHIP_LOYALTY_CONFIGURATION: string =
    "setEntityMembershipLoyaltyConfigurationResult";
      public static readonly RESULT_API_TRANSFER_REWARDS_TO_WALLET: string =
    "transferRewardsToWalletResult";
      public static readonly RESULT_API_GET_LATEST_UNPAID_INVOICE_STATUS_COUNT_FOR_DASHBOARD: string =
    "getLatestUnpaidInvoiveStatusCountForDashboardResult";
     public static readonly RESULT_API_GET_LATEST_UNPAID_INVOICE_STATUS_FOR_DASHBOARD: string =
    "getLatestUnpaidInvoiceStatusForDashboardResult";
     public static readonly RESULT_API_SET_ENTITY_PUBLIC_POST_PERMISSION_STATUS: string =
    "setEntityPublicPostPermissionStatusResult";
    public static readonly RESULT_API_GET_PUBLIC_POSTING_PERMISSION_STATUS: string =
    "getPublicPostingPermissionStatusResult";
    public static readonly RESULT_API_GET_CUSTOMER_DETAILS: string =
    "getCustomerDetailsResult";
      public static readonly RESULT_API_REQUEST_ENTITY_DOMAIN_MAPPING: string =
    "requestEntityDomainMappingResult";
      public static readonly RESULT_API_SET_BUSINESS_SOCIAL_LINKS: string =
    "setBusinessSocialLinksResult";
     public static readonly RESULT_API_SEND_REVIEW_REQUEST_VIA_EMAIL: string =
    "sendReviewRequestViaEmailResult";
    public static readonly RESULT_API_SEND_PAYMENT_INTIMATION_VIA_EMAIL: string =
    "sendPaymentIntimaionViaEmailResult";
    public static readonly RESULT_API_SEND_REVIEW_REQUEST_VIA_WHATSAPP: string =
    "sendReviewRequestViaWhatsAppResult";
    public static readonly RESULT_API_SEND_PAYMENT_INTIMATION_VIA_WHATSAPP: string =
    "sendPaymentIntimationViaWhatsAppResult";
     public static readonly RESULT_API_EDIT_MEMBER_ADDRESS: string =
    "editMemberAddressResult";
    public static readonly RESULT_API_EDIT_MEMBER_VIRTUAL_SESSION_INFO: string =
    "editMemberVirtualSessionInfoResult";
  
  //----------  STORAGE KEYS  ----------//
  public static readonly KEY_ACCOUNT_HASH_ID: string = "accountHashID";
  public static readonly KEY_ACCOUNT_AUTH_ID: string = "accountAuthID";
  public static readonly KEY_ACCOUNT_TOKEN_ID: string = "accTokenId";
  public static readonly KEY_NEW_ACCOUNT_PHONE_NUMBER: string =
    "newAccountPhoneNumber";
  public static readonly KEY_ACCOUNT_PHONE_NUMBER: string =
    "accountPhoneNumber";
  public static readonly KEY_ACCOUNT_COUNTRY_CODE: string =
    "accountCountryCode";
  public static readonly USER_SUBSCRIPTION_DATA: string =
    "userSubscriptionData";
  public static readonly OWNER_EMPLOYEE_HASH_ID: string = "ownerEmployeeHashId";
  public static readonly CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID: string =
    "currentEntityPubHash";
  public static readonly OWNER_NAME: string = "ownerName";
  public static readonly OWNER_IMAGE: string = "ownerImage";
  public static readonly PROFILE_HASH: string = "profileHash";
  public static readonly PROFILE_CODE: string = "profileCode";
  public static readonly CURRENT_ENTITY_NAME: string = "currentEntityName";
  public static readonly CURRENT_ENTITY_ADDRESS: string = "currentEntityAddress";
  public static readonly CURRENT_ENTITY_HASH: string = "currentEntityHash";
  public static readonly WHATSAPP_ACCESS: string = "waa";
  public static readonly SELECTED_PURCHASED_PLAN: string =
    "selectedpurchasedplan";
  public static readonly SELECTED_EMPLOYEE_PURCHASED_PLAN: string =
    "selectedEmployeepurchasedplan";
  public static readonly CURRENT_ROUTE_FOR_NEW_EMPLOYEE: string =
    "currentRouteForNewEmployee";
  public static readonly CURRENCY_FOR_SUBSCRIPTION_PAYMENT: string =
    "currencyCodeForSubscriptionPayment";
  public static readonly IS_ENTITY_FOREIGN: string =
    "isEntityForeign";
  public static readonly BUSINESS_POST_IMAGE_LIMIT: string =
    "bpil";
  public static readonly BUSINESS_POST_VIDEO_LIMIT: string =
    "bpvl";
  public static readonly BUSINESS_IMAGE_LIMIT: string =
    "biml";

      public static readonly EMPLOYEE_SHOP_SERVICE_INVOICE_ACCESS: string =
    "essia";
    public static readonly EMPLOYEE_HOME_SERVICE_INVOICE_ACCESS: string =
    "ehsia";
    public static readonly EMPLOYEE_VIRTUAL_SERVICE_INVOICE_ACCESS: string =
    "evsia";
        public static readonly EMPLOYEE_SHOP_SERVICE_OPERATION_ACCESS: string =
    "essoa";
    public static readonly EMPLOYEE_HOME_SERVICE_OPERATION_ACCESS: string =
    "ehsoa";
    public static readonly EMPLOYEE_VIRTUAL_SERVICE_OPERATION_ACCESS: string =
    "evsoa";
     public static readonly ENTITY_ADVANCE_PAYMENT_SETTINGS: string =
    "entadvpmtstng";

  //--------- TYPES ---------------------//
  public static readonly BUISNESS_PROMOTION: string = "buisnessPromotion";
  public static readonly ADMIN_POST: string = "adminPost";
  public static readonly SERVICE_ADD_UPDATE: string = "serviceAddEdit";
  public static readonly SERVICE_TEMPLATE_ADD: string = "serviceTemplateAdd";

  // -------------------ALERT/CONFIRM TYPES---------------------
  public static readonly CUSTOM_DIALOG_ALERT_TYPE: string = "alert";
  public static readonly CUSTOM_DIALOG_CONFIRM_TYPE: string = "confirm";

  /**-------------------FCM TOKEN-------------------------- */
  public static readonly KEY_FCM_TOKEN: string = "lookzupBusinessUserFCMToken";

  /**-------------------- MISC ----------------------------- */
  public static readonly REGEX_TYPE_NUMBER: string = "^[0-9]*$";
}
